var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledCrossRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live area 20x20"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Fill",
    cx: 9,
    cy: 9,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2558 10.0773C11.5816 10.4032 11.5816 10.9298 11.2558 11.2557C11.0933 11.4182 10.88 11.4998 10.6666 11.4998C10.4533 11.4998 10.24 11.4182 10.0775 11.2557L8.99996 10.1782L7.92246 11.2557C7.75996 11.4182 7.54663 11.4998 7.33329 11.4998C7.11996 11.4998 6.90663 11.4182 6.74413 11.2557C6.41829 10.9298 6.41829 10.4032 6.74413 10.0773L7.82163 8.99984L6.74413 7.92234C6.41829 7.5965 6.41829 7.06984 6.74413 6.744C7.06996 6.41817 7.59663 6.41817 7.92246 6.744L8.99996 7.8215L10.0775 6.744C10.4033 6.41817 10.93 6.41817 11.2558 6.744C11.5816 7.06984 11.5816 7.5965 11.2558 7.92234L10.1783 8.99984L11.2558 10.0773ZM8.99996 0.666504C4.40496 0.666504 0.666626 4.40484 0.666626 8.99984C0.666626 13.5948 4.40496 17.3332 8.99996 17.3332C13.595 17.3332 17.3333 13.5948 17.3333 8.99984C17.3333 4.40484 13.595 0.666504 8.99996 0.666504Z",
    fill: "#929596"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledCrossRound);
export default __webpack_public_path__ + "static/media/icon-filled-cross-round.dcc45a53d775ceb655bf3c62d9ef0fec.svg";
export { ForwardRef as ReactComponent };